import { BaseController } from "@repo/baseCloud";

import type {
	AppSettingSaveResult,
	ApplicationSetting,
	ApplicationSettingDefinition,
	ApplicationSettingToSave,
} from "../models";

export const controller = "ApplicationSettings";

export default class ApplicationSettingsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);

	/** Every setting definition */
	static getDefinitions() {
		return ApplicationSettingsApi.Get<ApplicationSettingDefinition[]>("GetDefinitions");
	}

	/** Every setting row, with its segment names. Secret settings come without their value (isMasked) */
	static getAllSettings() {
		return ApplicationSettingsApi.Get<ApplicationSetting[]>("GetAllSettings");
	}

	/**
	 * Adds (applicationSettingId 0) or updates a setting. Adding over an existing row for the same name and segment
	 * returns status Exists with that row, unless overwrite is true, which updates it instead.
	 */
	static saveSetting(setting: ApplicationSettingToSave, overwrite = false) {
		return ApplicationSettingsApi.Post<AppSettingSaveResult>("SaveSetting", { overwrite }, setting);
	}

	/** Deletes a setting row. deleted is false when it wasn't deleted, for example because it no longer exists */
	static deleteSetting(id: number) {
		return ApplicationSettingsApi.Post<{ deleted: boolean }>("DeleteSetting", { id });
	}
}
